import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#080808] border-t border-white/10 mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <Logo />
          <p className="mt-6 text-sm text-white/60 leading-relaxed max-w-sm">
            Brand-new cars on a practical path to ownership. Built for Australian
            ABN holders — no credit checks, just a clear way forward.
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="label-eyebrow mb-4">Explore</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/" className="hover:text-[#D4AF37]" data-testid="footer-home">Home</Link></li>
            <li><Link to="/about" className="hover:text-[#D4AF37]" data-testid="footer-about">About</Link></li>
            <li><Link to="/services" className="hover:text-[#D4AF37]" data-testid="footer-services">Services</Link></li>
            <li><Link to="/locations" className="hover:text-[#D4AF37]" data-testid="footer-locations">Locations</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="label-eyebrow mb-4">Get Started</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/apply" className="hover:text-[#D4AF37]" data-testid="footer-apply">Apply Now</Link></li>
            <li><Link to="/contact" className="hover:text-[#D4AF37]" data-testid="footer-contact">Contact</Link></li>
            <li><Link to="/services#calculator" className="hover:text-[#D4AF37]" data-testid="footer-calculator">Calculator</Link></li>
            <li><Link to="/portal/login" className="hover:text-[#D4AF37]" data-testid="footer-portal">Customer Portal</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="label-eyebrow mb-4">Reach Us</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-3">
              <Mail size={16} className="text-[#D4AF37] mt-0.5" />
              <a href="mailto:admin@keystoown.au" className="hover:text-white">admin@keystoown.au</a>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={16} className="text-[#D4AF37] mt-0.5" />
              <a href="tel:0422254888" className="hover:text-white">0422 254 888</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-[#D4AF37] mt-0.5" />
              <span>Servicing Sydney, Melbourne, Brisbane, Perth, Adelaide, Canberra, Hobart, Darwin</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40 tracking-wide">
            © {new Date().getFullYear()} Keys to Own. All rights reserved.
          </p>
          <p className="text-xs text-white/40">
            For Valid ABN Holders Using Vehicle For Business Purposes Only.
          </p>
        </div>
      </div>
    </footer>
  );
}
